import { createSlice } from '@reduxjs/toolkit';

export type State = {
	pageNumber: number;
	isLoadMoreVisible: boolean;
}

export const INITIAL_STATE: State = {
	pageNumber: 1,
	isLoadMoreVisible: true
};

const pagingSlice = createSlice({
	name: 'auditPaging',
	initialState: INITIAL_STATE,
	reducers: {
		auditNextPage(state) {
			state.pageNumber = state.pageNumber + 1;
		},
		auditResetPage(state) {
			state.pageNumber = 1;
		},
		setIsLoadMoreVisible(state, action) {
			state.isLoadMoreVisible = action.payload;
		}
	}
});

export const { auditNextPage, auditResetPage, setIsLoadMoreVisible } = pagingSlice.actions;
export default pagingSlice.reducer;
